import React, { useMemo } from "react";

import { FeatureFlag, useFeatures } from "components/FeatureFlag";

import { useClientCardMode } from "./hooks";
import ClientCardModeToggle from "./components/ClientCardModeToggle";
import { useWorkDesk } from "../../../Workspace/components/hooks";
import ClientCard from "./ClientCard";
import LegacyClientCard from "./LegacyClientCard";

function ClientCardDecider({ ...props }) {
  const ffWorkDesk = useFeatures("work-desk-beta");
  const { isWorkdeskClientPath } = useWorkDesk();
  const { showNewClientCard, toggleClientCardMode, loading } =
    useClientCardMode();

  const shouldRenderNewCard = showNewClientCard || isWorkdeskClientPath;

  const cardElement = useMemo(() => {
    if (shouldRenderNewCard) {
      // When the feature flag is on, ClientCardPreloader owns the new ClientCard.
      // Rendering it here would create a duplicate iframe.
      if (ffWorkDesk) return null;

      // Flag-off path: preserve today's behavior by wrapping ClientCard in the
      // container that previously lived inside ClientCard.jsx itself.
      return (
        <div
          style={{
            position: "absolute",
            top: "47px",
            left: "0px",
            width: "100vw",
            height: "calc(100vh - 57px)",
            backgroundColor: "white",
            zIndex: 109,
            overflow: "hidden",
          }}
        >
          <ClientCard />
        </div>
      );
    }

    return <LegacyClientCard {...props} />;
  }, [shouldRenderNewCard, ffWorkDesk, props]);

  return (
    <React.Fragment>
      <FeatureFlag id="client-card-reborn">
        {(!isWorkdeskClientPath || showNewClientCard) && (
          <ClientCardModeToggle
            loading={loading}
            enabled={showNewClientCard}
            onToggle={toggleClientCardMode}
          />
        )}
      </FeatureFlag>
      {cardElement}
    </React.Fragment>
  );
}

export default ClientCardDecider;
